import { IconGiftWithCircleBg, IconError } from "icons";

const portalStatusPopupIcons = {
  cancelled: IconError,
  completed: IconGiftWithCircleBg,
};

export default portalStatusPopupIcons;
